import { Banner, CreativityBanner, isCreativityBanner, CreativityType } from '../types/banner';

const hasDateField = (banner: Banner): banner is CreativityBanner<CreativityType> => {
  return isCreativityBanner(banner) && 'date' in banner.creativityConfig;
};

const sortByDateField = (a: CreativityBanner<CreativityType>, b: CreativityBanner<CreativityType>): number => {
  if (!('date' in a.creativityConfig) || !('date' in b.creativityConfig)) {
    return 0;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dateA = new Date(a.creativityConfig.date as string);
  const dateB = new Date(b.creativityConfig.date as string);

  const aIsPast = dateA < today;
  const bIsPast = dateB < today;

  if (aIsPast && !bIsPast) return 1;
  if (!aIsPast && bIsPast) return -1;

  return dateA.getTime() - dateB.getTime();
};

const sortByCreationDate = (a: Banner, b: Banner): number => {
  const dateA = new Date(a.createdAt);
  const dateB = new Date(b.createdAt);
  return dateB.getTime() - dateA.getTime();
};

export const sortBanners = (banners: Banner[]): Banner[] => {
  return [...banners].sort((a, b) => {
    if (hasDateField(a) && hasDateField(b)) {
      return sortByDateField(a, b);
    }
    return sortByCreationDate(a, b);
  });
};
